module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/195.0bcbc457.png";